import i18n from '../i18n';

export function renderGroupSystemMessage(message) {
  const event = message?.systemEvent || message?.system_event;
  if (event) {
    const params = message?.systemParams || message?.system_params || {};
    const name = params?.name || i18n.t('chat:chatContext.someoneFallback');
    return i18n.t(`chat:systemEvents.${event}`, { name, defaultValue: message?.content || '' });
  }
  return message?.content || '';
}

export default renderGroupSystemMessage;
